import { AutogenLayoutPayAdjustmentHistory } from "./autogen/AutogenLayoutPayAdjustmentHistory";
import {
    Component, DataSource, DataSourceMode, DataSourceModeChangeEvent, Label, Layout, Tab, Tabset
} from "@mcleod/components";
import { StringUtil } from "@mcleod/core";

export class PayAdjustmentHistory extends AutogenLayoutPayAdjustmentHistory {

    onLoad(): void | Promise<void> {
        this.layoutPayAdjustment.replaceMainDatasource(this.sourceDrsDeductHist);
        this.rebindDataSource(this.layoutPayAdjustment.sourceJournalDriver, this.sourceJournalDriver);
        this.sourceDrsDeductHist.addAfterModeChangeListener((event: DataSourceModeChangeEvent) => {
            this.dataheaderPayAdjustment.showExecute = event.newMode === DataSourceMode.SEARCH;
            if (event.newMode !== DataSourceMode.SEARCH) {
                this.disableFields();
                this.setTitle();
            }
        });
        this.sourceDrsDeductHist.addAfterExecutionListener(() => {
            this.layoutPayAdjustment.textboxOrderId.quickInfoOverrideMethod = async () => {
                return Layout.getLoadedLayoutWithData("lme/settlement/OrderPayablesOrderIdQuickInfo", null, this.activeRow.get("movement_id"));
            }
        });
        this.layoutPayAdjustment.textboxVoidDate.visible = true;
        this.layoutPayAdjustment.checkboxIsVoid.visible = true;
        this.layoutPayAdjustment.textboxCheckDate.visible = true;
        this.layoutPayAdjustment.textboxTaxType.visible = true;
        this.layoutPayAdjustment.textboxTaxCode.visible = true;
        this.layoutPayAdjustment.textboxEmployerTaxLiab.visible = true;
        this.layoutPayAdjustment.textboxProcessStatus.visible = false;
        this.layoutPayAdjustment.textboxBackOfficeReasonCode.visible = false;
        this.layoutPayAdjustment.textboxReasonCodeComment.visible = false;
        this.layoutPayAdjustment.textboxStatus.visible = false;
        this.layoutPayAdjustment.textboxCurrency.visible = false;
    }

    private disableFields() {
        this.layoutPayAdjustment.tabsetPayAdjustments.tabs.forEach((tab: Tab) => {
            tab.forEveryChildComponent((component: Component) => {
                if (component instanceof Tabset || component instanceof Label) {
                    return;
                }
                component.enabled = false;
            });
        });
    }

    rebindDataSource(oldDatasource: DataSource, newDatasource: DataSource) {
        if (newDatasource != null) {
            oldDatasource.rebindComponentsTo(newDatasource);
            newDatasource.attachListeners(oldDatasource);
            oldDatasource = newDatasource;
            this[oldDatasource.id] = newDatasource;
        }
    }

    protected setTitle() {
        if (this.mainDataSource.mode === DataSourceMode.ADD || this.mainDataSource.mode === DataSourceMode.SEARCH) {
            return;
        }
        const orderId = this.mainDataSource.activeRow?.get("order_id");
        const payeeData = this.mainDataSource.activeRow?.getLookupModelData("payee_id");
        const payee = payeeData && payeeData[0] ? " - " + payeeData[0].get("name") : "";
        const titleSuffix = StringUtil.isEmptyString(orderId) ? payee : " - " + orderId + payee;
        this.dataHeader.title = this.titleSingular + titleSuffix;
    }
}
